// const BASEURL = 'http://localhost:5000/api';  // localhost

const BASEURL = process.env.REACT_APP_API_URI;
export const S3_BUCKET_NAME = process.env.REACT_APP_S3_BUCKET_NAME;
export const AZURE_BLOB_STORAGE = process.env.REACT_APP_AZURE_STORAGE_ACCOUNT;
export const DATABASE_NAME = process.env.REACT_APP_PG_DATABASE_NAME;
export const AWS_CONFIG_TYPE = process.env.REACT_APP_AWS_CONFIG_TYPE === 'true';
export const PROFILE_ENV = process.env.REACT_APP_PROFILE_ENV || 'no_profile_env';
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const TENANT_ID = process.env.REACT_APP_TENANT_ID;
export const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;
// export const REDIRECT_URI = 'http://localhost:3000'
export const COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID;
export const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN;


export const BACKEND_VDE_BASEURL = 'https://depllm.eastus.cloudapp.azure.com'; // VDE URL for deployed
export const OPEN_AI_URL = 'https://depgenopenai.eastus.cloudapp.azure.com';
export const AWS_UI_URL = 'https://dev-aws.xmdm360-ai.com/';
export const AZURE_UI_URL = 'https://dev.xmdm360-ai.com/';
// export const SNOWFLAKE_UI_URL = 'http://dep-snowpark-react-frontend-env.us-east-1.elasticbeanstalk.com/';
export const ETL_COPILOT_WEB_SOCKET_URL = `wss://dep-etl-copilot.dep-ai.com/ws`;
export const DQ_AGENT_WEB_SOCKET_URL = `wss://dq-agent.dep-ai.com/ws/logs`;

export default BASEURL;
